import { useState } from "react";
import { PendingTasksDto, GDPRNoConsentPatientDto, DocumentWithNoFileDto } from "../types/pendingTasks";
import { pendingTasksService } from "../services/pendingTasksService";
import { useApi } from "./useApi";

export const usePendingTasks = () => {
  // Το backend σου γυρίζει ένα ενιαίο PendingTasksDto αντικείμενο
  const {
    data: pendingTasksData,
    loading: isLoading,
    error,
    refetch: fetchPendingTasks,
  } = useApi<PendingTasksDto>("pending-tasks", (signal) => pendingTasksService.getPendingTasks(signal));

  // Ξεχωρίζουμε τα DTOs καθαρά σε ξεχωριστές μεταβλητές
  const gdprNoConsentList: GDPRNoConsentPatientDto[] = pendingTasksData?.gdprNoConsentList ?? [];
  const documentsWithNoFileList: DocumentWithNoFileDto[] = pendingTasksData?.documentsWithNoFileList ?? [];

  const [modalState, setModalState] = useState<{
    isOpen: boolean;
    title: string;
    message: string;
    type: "success" | "error";
  }>({
    isOpen: false,
    title: "",
    message: "",
    type: "success",
  });

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  return {
    gdprNoConsentList,         // <--- Η λίστα με τα GDPR DTOs ξεχωριστά
    documentsWithNoFileList,    // <--- Η λίστα με τα Documents DTOs ξεχωριστά
    isLoading,
    error,
    fetchPendingTasks: () => fetchPendingTasks(true),
    modalState,
    closeModal,
  };
};